import { connect } from 'react-redux'
import {changeTheme,changeUnit,changeRouteStyle} from '../actions'
import MyCustomForm from '../components/MyCustomForm'

const mapStateToProps = (state) => {
    return state.poster;
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeTheme: (value) => {
            dispatch(changeTheme(value));
        },
        onChangeUnit: (value) => {
            dispatch(changeUnit(value));
        },
        onChangeRouteStyle: (key,value) => {
            dispatch(changeRouteStyle(key,value));
        }
    }
}

const RxMyCustomForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyCustomForm)

export default RxMyCustomForm


// WEBPACK FOOTER //
// ./src/containers/RxMyCustomForm.js